import React from "react";
import { Link } from "react-router-dom";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { useT } from "@/context/LanguageContext";
import { ArrowRight } from "@phosphor-icons/react";

export function Categories({ categories = [] }) {
  const { t } = useT();
  return (
    <section className="bg-mist py-24 lg:py-32" data-testid="categories-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <SectionHeading
            overline={t("categories.overline")}
            title={t("categories.title")}
            subtitle={t("categories.subtitle")}
          />
          <Link to="/products" className="shrink-0 text-sm font-semibold text-teal hover:underline" data-testid="categories-view-all">
            {t("categories.viewAll")}
          </Link>
        </div>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, i) => (
            <Reveal key={c.name} delay={(i % 3) * 0.08}>
              <Link
                to="/contact?type=quote"
                data-testid={`category-card-${i}`}
                className="group relative block h-64 overflow-hidden rounded-xl"
              >
                <img src={c.image} alt={c.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F] via-[#0A192F]/30 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-6">
                  <h3 className="font-heading text-xl font-semibold text-white">{c.name}</h3>
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur-sm transition-all duration-300 group-hover:bg-teal">
                    <ArrowRight size={18} weight="bold" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
